const MIYABIYA_WISHLIST_KEY = 'miyabiya:wishlist:v1';
const isJapanese = document.documentElement.lang?.toLowerCase().startsWith('ja');

const labels = {
  add: isJapanese ? 'お気に入りに追加' : 'Add to wishlist',
  added: isJapanese ? 'お気に入り追加済み' : 'Added to wishlist',
  title: isJapanese ? 'お気に入りリスト' : 'Wishlist',
  empty: isJapanese ? 'お気に入りに追加した商品はまだありません。' : 'Your wishlist is empty.',
  view: isJapanese ? '商品を見る' : 'View product',
  clear: isJapanese ? 'すべて削除' : 'Clear all',
  close: isJapanese ? '閉じる' : 'Close',
};

const readWishlist = () => {
  try {
    const items = JSON.parse(localStorage.getItem(MIYABIYA_WISHLIST_KEY) || '[]');
    return Array.isArray(items) ? items.filter((item) => item?.id) : [];
  } catch (error) {
    return [];
  }
};

const writeWishlist = (items) => {
  localStorage.setItem(MIYABIYA_WISHLIST_KEY, JSON.stringify(items));
};

const getProductFromButton = (button) => ({
  id: button.dataset.productId,
  title: button.dataset.productTitle,
  url: button.dataset.productUrl,
  image: button.dataset.productImage,
  price: button.dataset.productPrice,
});

const isWishlisted = (id) => readWishlist().some((item) => item.id === id);

const updateButtons = () => {
  const items = readWishlist();
  const ids = new Set(items.map((item) => item.id));

  document.querySelectorAll('[data-miyabiya-wishlist-toggle]').forEach((button) => {
    const active = ids.has(button.dataset.productId);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
    const label = button.querySelector('span:not([aria-hidden])');
    if (label) label.textContent = active ? labels.added : labels.add;
    button.setAttribute('aria-label', active ? labels.added : labels.add);
  });

  document.querySelectorAll('[data-miyabiya-wishlist-count]').forEach((count) => {
    count.textContent = String(items.length);
    count.hidden = items.length === 0;
  });

  document.querySelectorAll('[data-miyabiya-wishlist-open]').forEach((button) => {
    button.classList.toggle('is-active', items.length > 0);
  });
};

const toggleWishlist = (button) => {
  const product = getProductFromButton(button);
  if (!product.id) return;

  const items = readWishlist();
  const existingIndex = items.findIndex((item) => item.id === product.id);

  if (existingIndex >= 0) {
    items.splice(existingIndex, 1);
  } else {
    items.unshift(product);
  }

  writeWishlist(items);
  updateButtons();
  renderPanel();
};

const createPanel = () => {
  if (document.querySelector('[data-miyabiya-wishlist-panel]')) return;

  const panel = document.createElement('aside');
  panel.className = 'miyabiya-wishlist-panel';
  panel.setAttribute('data-miyabiya-wishlist-panel', '');
  panel.setAttribute('aria-hidden', 'true');
  panel.innerHTML = `
    <div class="miyabiya-wishlist-panel__backdrop" data-miyabiya-wishlist-close></div>
    <div class="miyabiya-wishlist-panel__dialog" role="dialog" aria-modal="true" aria-label="${labels.title}">
      <div class="miyabiya-wishlist-panel__header">
        <h2>${labels.title}</h2>
        <button type="button" data-miyabiya-wishlist-close aria-label="${labels.close}">×</button>
      </div>
      <div class="miyabiya-wishlist-panel__items" data-miyabiya-wishlist-items></div>
      <button type="button" class="miyabiya-wishlist-panel__clear" data-miyabiya-wishlist-clear>${labels.clear}</button>
    </div>
  `;
  document.body.append(panel);
};

const renderPanel = () => {
  createPanel();
  const panel = document.querySelector('[data-miyabiya-wishlist-panel]');
  const list = panel?.querySelector('[data-miyabiya-wishlist-items]');
  const clear = panel?.querySelector('[data-miyabiya-wishlist-clear]');
  const items = readWishlist();

  if (!list || !clear) return;

  clear.hidden = items.length === 0;
  list.innerHTML = items.length
    ? items
        .map(
          (item) => `
            <article class="miyabiya-wishlist-panel__item">
              ${item.image ? `<img src="${item.image}" alt="">` : ''}
              <div>
                <h3>${item.title || ''}</h3>
                ${item.price ? `<p>${item.price}</p>` : ''}
                <a href="${item.url || '#'}">${labels.view}</a>
              </div>
              <button type="button" data-miyabiya-wishlist-remove="${item.id}" aria-label="${labels.close}">×</button>
            </article>
          `
        )
        .join('')
    : `<p class="miyabiya-wishlist-panel__empty">${labels.empty}</p>`;
};

const openPanel = () => {
  renderPanel();
  const panel = document.querySelector('[data-miyabiya-wishlist-panel]');
  panel?.classList.add('is-open');
  panel?.setAttribute('aria-hidden', 'false');
};

const closePanel = () => {
  const panel = document.querySelector('[data-miyabiya-wishlist-panel]');
  panel?.classList.remove('is-open');
  panel?.setAttribute('aria-hidden', 'true');
};

const addMediaButton = () => {
  const source = document.querySelector('[data-miyabiya-wishlist-toggle][data-product-id]');
  const media = document.querySelector('.product-information__media media-gallery, .product-information__media');

  if (!source || !media || media.querySelector('.miyabiya-wishlist-media-button')) return;

  const button = source.cloneNode(true);
  button.className = 'miyabiya-wishlist-media-button';
  button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
  button.setAttribute('aria-label', labels.add);
  media.append(button);
};

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-miyabiya-wishlist-toggle]');
  if (toggle) {
    toggleWishlist(toggle);
    return;
  }

  if (event.target.closest('[data-miyabiya-wishlist-open]')) {
    openPanel();
    return;
  }

  if (event.target.closest('[data-miyabiya-wishlist-close]')) {
    closePanel();
    return;
  }

  const removeButton = event.target.closest('[data-miyabiya-wishlist-remove]');
  if (removeButton) {
    writeWishlist(readWishlist().filter((item) => item.id !== removeButton.dataset.miyabiyaWishlistRemove));
    updateButtons();
    renderPanel();
    return;
  }

  if (event.target.closest('[data-miyabiya-wishlist-clear]')) {
    writeWishlist([]);
    updateButtons();
    renderPanel();
  }
});

addMediaButton();
updateButtons();
renderPanel();
